import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Form } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import Select from 'react-select';
import {
  DataTable,
  DataTableItem,
  Loader,
  PaginationComponent,
  SearchBar,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getAllCustomerGroupsAsync,
  selectCustomerGroups,
  selectCustomerGroupsPagination,
  selectCustomerGroupsLoadingStatus,
  GroupsFilter,
} from '../Users/identityUsersSlice';
import { LOADING_STATUS } from '../../common/constants';
import { InitialPaginationParameters } from '../../common/types/pagination.types';

function CustomerGroups() {
  const dispatch = useAppDispatch();
  const customerGroups = useAppSelector(selectCustomerGroups);
  const [searchTerm, setSearchTerm] = useState(null);
  const customerGroupsPagination = useAppSelector(
    selectCustomerGroupsPagination,
  );
  const customerGroupsLoadingStatus = useAppSelector(
    selectCustomerGroupsLoadingStatus,
  );
  const [accountsSearchFilter, setAccountsSearchFilter] =
    useState<GroupsFilter>({
      PageNumber: InitialPaginationParameters.PageNumber,
      PageSize: InitialPaginationParameters.PageSize,
      SearchString: searchTerm,
      Culture: 'fi_FI',
    });

  // gets translated item based on keyId and locale
  // this is used in html to fetch proper translation of text
  function getItem(locale, keyId, item) {
    if (customerGroupsLoadingStatus === LOADING_STATUS.IDLE) {
      const found = item.translations.filter(
        a => a.locale === locale && a.keyId === keyId,
      );
      if (found && found[0] && found[0].text) {
        return found[0].text;
      }
    }
    return '';
  }

  const [customerGroupsTableItems, setCustomerGroupsTableItems] = useState<
    DataTableItem[]
  >([]);

  useEffect(() => {
    if (customerGroups && customerGroups.length > 0) {
      const formattedCustomerGroupsList: DataTableItem[] = [];
      customerGroups?.forEach(item => {
        formattedCustomerGroupsList.push({
          ItemId: item.id,
          Items: [getItem('fi_FI', 'CustomerGroupName', item)],
          Url: `/customers/customergroups/details/${item.id}`,
        });
      });
      setCustomerGroupsTableItems(formattedCustomerGroupsList);
    }
  }, [customerGroups]);

  // calls actual search, which calls internal getAllCustomerGroupsAsync
  // and that is then routed to backend
  const doSearch = event => {
    if (event !== null) {
      event.preventDefault();
    }

    const modifiedSearchFilter = accountsSearchFilter;
    modifiedSearchFilter.PageNumber = InitialPaginationParameters.PageNumber;
    modifiedSearchFilter.SearchString = searchTerm;
    dispatch(getAllCustomerGroupsAsync(modifiedSearchFilter));
  };
  const handleInputChange = event => {
    const { target } = event;
    const { value, name } = target;
    setSearchTerm(value);
  };

  const HandlePaginationClick = (Page: number) => {
    const paginatedFiltering = accountsSearchFilter;
    paginatedFiltering.PageNumber = Page;
    setAccountsSearchFilter(paginatedFiltering);
    dispatch(getAllCustomerGroupsAsync(paginatedFiltering));
  };

  // const AddNewButton: JSX.Element = (
  //   <Link
  //     to="/customers/customergroups/addnew"
  //     className="btn btn-blue ps-16"
  //   >
  //     <Icon CssClass="me-8" AriaLabel="Uusi" Name="plus" />
  //     Lisää uusi (TODO)
  //   </Link>
  // );

  // draws elements to browser
  return (
    <>
      <Helmet>
        <title>Asiakas Ryhmät - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Asiakkaat ja ryhmät']}
          Title="Asiakasryhmät"
        />

        <SearchBar
          FreeTextOnChangeHandler={handleInputChange}
          FreeTextPlaceholder="Hae..."
          SearchHandler={doSearch}
          IsLoading={customerGroupsLoadingStatus !== LOADING_STATUS.IDLE}
          Value={searchTerm}
        />
        <Loader
          IsLoading={customerGroupsLoadingStatus === LOADING_STATUS.LOADING}
        />

        {customerGroupsLoadingStatus === LOADING_STATUS.IDLE &&
          customerGroups !== null &&
          customerGroups.length > 0 && (
            <>
              <DataTable
                ColumnWidths={[400, null]}
                Header={['Ryhmän nimi']}
                Items={customerGroupsTableItems}
                LegendText="asiakasryhmää"
                TotalItems={customerGroupsPagination.totalCount}
              />
              <PaginationComponent
                OnPageClick={HandlePaginationClick}
                PaginationData={customerGroupsPagination}
              />
            </>
          )}

        {customerGroupsLoadingStatus === LOADING_STATUS.IDLE &&
          customerGroups != null &&
          customerGroups.length < 1 && <p>Ei asiakasryhmiä.</p>}
      </Container>
    </>
  );
}

export default CustomerGroups;
